import React, {Component} from 'react'
import ImageInCoverStyle from '../../../common/helpers/ImageInCoverStyle'

class TopExperienceBox extends Component {
  render() {
    return (
      <div className="col-md-6 widget">
        <div className="title">Top 5</div>
        <div className="row">
          <div className="col">
            {this.props.experiences.map((item, i) => (
              <div key={i} className="row mb-2">
                <div className="col-1">
                  <ImageInCoverStyle imageUrl={item.PosterUrl} width="36px" height="48px" />
                </div>
                <div className="col-11">
                  <a href={item.TmdbWebUrl}>{item.OriginalTitle}</a>
                  <br />
                  {item.ReleaseDate}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export default TopExperienceBox
